import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TrustStrip from "./components/TrustStrip";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import DifferentiatorsSection from "./components/DifferentiatorsSection";
import ExperienceSection from "./components/ExperienceSection";
import TrainingSection from "./components/TrainingSection";
import FAQSection from "./components/FAQSection";
import AppPreviewSection from "./components/AppPreviewSection";
import PartnershipCTASection from "./components/PartnershipCTASection";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <div id="hero">
          <HeroSection />
        </div>
        <TrustStrip />
        <div id="about">
          <AboutSection />
        </div>
        <div id="services">
          <ServicesSection />
        </div>
        <DifferentiatorsSection />
        <ExperienceSection />
        <div id="training">
          <TrainingSection />
        </div>
        <div id="faq">
          <FAQSection />
        </div>
        <AppPreviewSection />
        <div id="partnership">
          <PartnershipCTASection />
        </div>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
